import React, { useState, useCallback, useEffect } from 'react';

const TAG_ID = `EB_SCRIPT_${Date.now()}`;
const SCRIPT_URL = 'https://www.eventbrite.com/static/widgets/eb_widgets.js';

const useEventbrite = ({
  eventId,
  modal,
  onOrderComplete,
  promoCode,
}) => {
  const id = `EB_${eventId}`;
  const [isLoaded, setLoaded] = useState(false);
  const onLoad = useCallback(() => setLoaded(true), []);
  const onErr = useCallback(e => {
    console.error(e);

    setLoaded(false);
  }, []);

  useEffect(() => {
    if (!eventId) {
      setLoaded(false);
      return;
    }

    if (window?.EBWidgets) {
      setLoaded(true);
      return;
    }

    const existing = document.getElementById(TAG_ID);

    if (existing) {
      existing.remove();
    }

    const script = document.createElement('script');
    script.id = TAG_ID;
    script.async = true;
    script.src = SCRIPT_URL;
    script.addEventListener('load', onLoad);
    script.addEventListener('error', onErr);
    script.addEventListener('abort', onErr);
    document.head.appendChild(script);

    return () => {
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onErr);
      script.removeEventListener('abort', onErr);
      script.remove();
      setLoaded(false);
    };
  }, [
    setLoaded,
    onLoad,
    onErr,
  ]);

  useEffect(() => {
    if (!eventId || !isLoaded) {
      return;
    }

    const config = {
      widgetType: 'checkout',
      eventId,
      onOrderComplete,
      modal,
    };

    if (modal) {
      config.modalTriggerElementId = id;
    }

    if (promoCode) {
      config.promoCode = promoCode;
    }

    window.EBWidgets.createWidget(config);
  }, [isLoaded, eventId, modal, promoCode]);

  return eventId && isLoaded ? { id } : null;
};

export default useEventbrite;
